const SideMenuGroupExpandIcon = () => {
  return (
    <svg
      className='side-menu-expand-icon'
      width='12'
      height='8'
      viewBox='0 0 12 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 1.5L6 6L10.5 1.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SideMenuGroupExpandIcon;
